import { LandingPage, AuthService } from '@common/generic';
import { Injectable } from '@angular/core';

@Injectable()
export class DefaultLandingPage  implements LandingPage {
    constructor(private auth: AuthService) {

    }
    navigate() {
        this.auth.goToLoginPage();
    }
}
